import React from "react";
import ContactForm from "../ContactFrom";

import cnt1 from "../../images/icon/home.svg";
import cnt2 from "../../images/icon/mail-2.svg";
import cnt3 from "../../images/icon/app.svg";

const Contactpage = () => {
  return (
    <section className="wpo-contact-pg-section section-padding">
      <div className="container">
        <div className="row">
          <div className="col col-lg-10 offset-lg-1">
            <div className="office-info">
              <div className="row">
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <img src={cnt1} alt="" />
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Address</h2>
                      <p>
                        {" "}
                        No.422, 4th floor, Sanvik plaza, Wakwella Road, Galle, Sri Lanka.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <img src={cnt2} alt="" />
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Email Us</h2>
                      <p> info@knowebsolutions.com</p>
                      <p>help@knowebsolutions.com</p>
                    </div>
                  </div>
                </div>
                <div className="col col-xl-4 col-lg-6 col-md-6 col-12">
                  <div className="office-info-item">
                    <div className="office-info-icon">
                      <div className="icon">
                        <img src={cnt3} alt="" />
                      </div>
                    </div>
                    <div className="office-info-text">
                      <h2>Call Now</h2>
                      <p>(+94)70 24 93 211</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="wpo-contact-title">
              <h2>Have Any Question?</h2>
              <p>Start Your Digital Journey with Us.</p>
            </div>
            <div className="wpo-contact-form-area">
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
      <section className="wpo-contact-map-section">
        <div className="wpo-contact-map">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12030.493689769417!2d80.21402343296981!3d6.03551895792636!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae173bba7051d79%3A0xf009ef4c921a2a90!2sSanvik%2C%20Wakwella%20Rd%2C%20Galle%2080000!5e0!3m2!1sen!2slk!4v1752056593247!5m2!1sen!2slk"></iframe>
        </div>
      </section>
    </section>
  );
};

export default Contactpage;
